import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingPage from "../components/LoadingPage";
import {
  checkDanhXungEnglish,
  getHangChoChange,
  isEmptyObject,
  moneyFormatComma,
} from "../helpers/function_helper";
const Response = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [sweetAlert, setSweetAlert] = useState({
    isShow: false,
    baseProps: {},
  });
  const [loading, setLoading] = useState(false);
  const [responseChangBay, setResponseChangBay] = useState([]);
  const [responseChuyenBay, setResponseChuyenBay] = useState([]);

  const [expanded, setExpanded] = useState({});

  // Lưu flag vào localStorage khi vào trang Response
  useEffect(() => {
    localStorage.setItem("isOnResponsePage", "true");
  }, []);

  useEffect(() => {
    var responseChuyenBay = [];
    var responseChangBay = [];
    var data = location.state.data;
    data.forEach((item) => {
      if (item.code == 200) {
        responseChuyenBay.push(item.data);
        responseChangBay.push(...item.data.chang_bay);
      }
    });
    setResponseChuyenBay(responseChuyenBay);
    setResponseChangBay(responseChangBay);
  }, [location.state]);

  const groupByIndexChangBay = (arr, valueFn, options = {}) => {
    if (!Array.isArray(arr)) return "";
    const grouped = arr.reduce((acc, item) => {
      const idx = item.index_chang_bay ?? 0;
      if (!acc[idx]) acc[idx] = [];
      acc[idx].push(item);
      return acc;
    }, {});
    const keys = Object.keys(grouped).sort((a, b) => Number(a) - Number(b));
    if (options.hlkg) {
      // Hiển thị quy_dinh_ve.hanh_ly_xach_tay từ chuyenBay[index_chang_bay] sau mỗi nhóm
      const chuyenBay = options.chuyenBayArr || [];
      return keys
        .map((idx) => {
          const groupStr = grouped[idx].map(valueFn).join(", ");
          const hlkg = chuyenBay[idx]?.quy_dinh_ve?.hanh_ly_ky_gui || "";
          return groupStr + (hlkg ? ` , ${hlkg} ` : "");
        })
        .join(" + ");
    }
    // Mặc định
    return keys.map((idx) => grouped[idx].map(valueFn).join(", ")).join(" + ");
  };

  return (
    <section id="tour_booking_submission" className="section_padding">
      {loading && <LoadingPage />}
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="tou_booking_form_Wrapper">
              <div className="booking_tour_form">
                <h3 className="heading_theme">Thông tin vé</h3>
                <div className="tour_booking_form_box">
                  <div className="row">
                    {/* Table 1: Thông tin chuyến bay */}

                    <div className="col-12 mb-3">
                      {location.state.data
                        .filter((item) => item.code == 200)
                        .map((item, i) => {
                          return (
                            <div key={item.code}>
                              <h5 className="mb-2" style={{ fontSize: 20 }}>
                                Mã đặt chỗ: <strong>{item.data.ve.pnr}</strong>
                              </h5>
                            </div>
                          );
                        })}
                    </div>
                    {/* Card: Thông tin chuyến bay */}
                    <div className="col-lg-6 col-12 mb-3">
                      <h5 className="mb-1" style={{ fontSize: 20 }}>
                        Thông tin chuyến bay
                      </h5>
                      <div className="row">
                        {responseChangBay.map((flight, flightIndex) => (
                          <div
                            key={flightIndex}
                            className={"col-lg-12 col-12 mt-2"}
                          >
                            <div
                              className="card"
                              style={{
                                border: "1px solid #e0e6ed",
                                borderRadius: 12,
                                boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                                background:
                                  "linear-gradient(135deg, #f8fbff 0%, #e8f4fd 100%)",
                                overflow: "hidden",
                              }}
                            >
                              <div className="card-body p-4">
                                <div className="row align-items-center">
                                  <div className="col-lg-2 col-md-3 text-center mb-3 mb-md-0">
                                    {flight?.logo && (
                                      <img
                                        src={flight.logo}
                                        alt="logo"
                                        style={{
                                          width: "80px",
                                          height: "auto",
                                          // borderRadius: 8,
                                          // boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                                        }}
                                      />
                                    )}
                                  </div>
                                  <div className="col-lg-10 col-md-9">
                                    <div className="row">
                                      <div className="col-lg-4 col-6 mb-3 text-center">
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: "#666",
                                            fontWeight: 500,
                                          }}
                                        >
                                          Số hiệu chuyến bay
                                        </div>
                                        <div
                                          style={{
                                            fontSize: 16,
                                            fontWeight: 600,
                                            color: "#1976d2",
                                          }}
                                        >
                                          {flight?.so_hieu || ""}
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-6 mb-3 text-center">
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: "#666",
                                            fontWeight: 500,
                                          }}
                                        >
                                          Ngày bay
                                        </div>
                                        <div
                                          style={{
                                            fontSize: 15,
                                            fontWeight: 600,
                                            color: "#333",
                                          }}
                                        >
                                          {flight?.ngay_di
                                            .split(" ")[0]
                                            ?.replaceAll("-", "/")}
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-6 mb-3 text-center">
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: "#666",
                                            fontWeight: 500,
                                          }}
                                        >
                                          Hạng vé
                                        </div>
                                        <div
                                          style={{
                                            fontSize: 15,
                                            fontWeight: 600,
                                            color: "#333",
                                          }}
                                        >
                                          {getHangChoChange(
                                            flight?.loai_hang_ve
                                          )}
                                        </div>
                                      </div>
                                      {/* </div>
                                    <div className="row mt-2"> */}
                                      <div className="col-lg-4 col-6 mb-2 text-center">
                                        <div className="d-flex align-items-center justify-content-center">
                                          <div>
                                            <div
                                              style={{
                                                fontSize: 18,
                                                fontWeight: 700,
                                                color: "#1976d2",
                                              }}
                                            >
                                              {flight?.ngay_di
                                                .split(" ")[1]
                                                .split(":")
                                                .slice(0, 2)
                                                .join(":")}
                                            </div>
                                            <div
                                              style={{
                                                fontSize: 13,
                                                color: "#666",
                                              }}
                                            >
                                              {flight?.tinh_di || ""} (
                                              {flight?.diem_di || ""})
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-6 text-center mb-2 d-flex align-items-center justify-content-center">
                                        <div>
                                          <div
                                            style={{
                                              fontSize: 12,
                                              color: "#666",
                                            }}
                                          >
                                            {flight?.thoi_gian_bay || ""}
                                          </div>
                                          <div
                                            style={{
                                              borderTop: "2px solid #1976d2",
                                              margin: "4px 0",
                                              position: "relative",
                                            }}
                                          >
                                            <i
                                              className="fas fa-plane"
                                              style={{
                                                position: "absolute",
                                                top: "-9px",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                color: "#1976d2",
                                                background: "#eff6fe",
                                                padding: "0 4px",
                                              }}
                                            ></i>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-6 mb-2 text-center">
                                        <div className="d-flex align-items-center justify-content-center">
                                          <div>
                                            <div
                                              style={{
                                                fontSize: 18,
                                                fontWeight: 700,
                                                color: "#1976d2",
                                              }}
                                            >
                                              {flight?.ngay_den
                                                .split(" ")[1]
                                                .split(":")
                                                .slice(0, 2)
                                                .join(":")}
                                            </div>
                                            <div
                                              style={{
                                                fontSize: 13,
                                                color: "#666",
                                              }}
                                            >
                                              {flight?.tinh_den || ""} (
                                              {flight?.diem_den || ""})
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* Card: Thông tin hành khách */}
                    <div className="col-lg-6 col-12">
                      <h5 className="mb-2" style={{ fontSize: 20 }}>
                        Thông tin hành khách
                      </h5>
                      <div className="row">
                        {/* Danh sách hành khách và chi tiết giá */}
                        <div>
                          {(() => {
                            // Nếu có flight.hang_bay.api === "uAPI" thì chỉ lấy chiều đi (chieuIdx === 0)
                            let filteredFlights = responseChuyenBay;

                            return filteredFlights.map(
                              (chuyenBay, chuyenBayidx) => (
                                <div
                                  key={chuyenBayidx}
                                  style={{ marginBottom: 12 }}
                                >
                                  {chuyenBay.chang_bay.map((flight, chieuIdx) => {
                                      if(chuyenBay.ve.hang_bay == "uAPI" && chieuIdx > 0) return null;
                                      return (
                                        <div
                                          key={chieuIdx}
                                          style={{ marginBottom: 12 }}
                                        >
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            fontSize: 18,
                                            marginBottom: 4,
                                            color: "#1976d2",
                                          }}
                                        ></div>
                                        <div>
                                          {chuyenBay.hanh_khach.map(
                                            (p, idx) => {
                                              // Tính tổng tiền của hành khách này cho chiều này
                                              let fareType = p.gia_ve[chieuIdx];
                                              let price =
                                                p.gia_ve[chieuIdx].gia_dai_ly + (chuyenBay.ve.hang_bay == "uAPI" ? p.gia_ve.slice(1).reduce((sum, item) => sum + (item.phi_dai_ly || 0), 0) : 0)

                                              let hanhLyArr =
                                                p.gia_ve[chieuIdx].hanh_ly;
                                              let gheArr =
                                                p.gia_ve[chieuIdx].cho_ngoi;
                                              let dvArr =
                                                p.gia_ve[chieuIdx].dich_vu;

                                              const isExpanded =
                                                expanded[
                                                  `${chuyenBayidx}-${chieuIdx}-${idx}`
                                                ] || false;

                                              return (
                                                <div
                                                  key={idx}
                                                  style={{
                                                    border: "1px solid #e0e0e0",
                                                    borderRadius: 8,
                                                    marginBottom: 8,
                                                    background: isExpanded
                                                      ? "linear-gradient(90deg,#e3f0ff 0%,#f8fbff 100%)"
                                                      : "linear-gradient(90deg,#f8fbff 0%,#e3f0ff 100%)",
                                                    transition:
                                                      "background 0.2s",
                                                    cursor: "pointer",
                                                    padding: isExpanded
                                                      ? "14px 0px 0px 0px"
                                                      : "14px 0px",
                                                    fontWeight: 500,
                                                    boxShadow: isExpanded
                                                      ? "0 2px 8px rgba(25,118,210,0.08)"
                                                      : "none",
                                                    fontSize: 14,
                                                  }}
                                                  onClick={() =>
                                                    setExpanded((prev) => ({
                                                      ...prev,
                                                      [`${chuyenBayidx}-${chieuIdx}-${idx}`]:
                                                        !prev[
                                                          `${chuyenBayidx}-${chieuIdx}-${idx}`
                                                        ],
                                                    }))
                                                  }
                                                >
                                                  <span
                                                    style={{ marginLeft: 8 }}
                                                  >
                                                    {p.ten_tat}
                                                  </span>
                                                  <span
                                                    style={{
                                                      float: "right",
                                                      color: "#1976d2",
                                                      marginRight: 8,
                                                      fontWeight: 700,
                                                      fontSize: 18,
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: 6,
                                                    }}
                                                  >
                                                    {moneyFormatComma(price)}
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        transition:
                                                          "transform 0.2s",
                                                        transform: isExpanded
                                                          ? "rotate(90deg)"
                                                          : "rotate(0deg)",
                                                      }}
                                                    >
                                                      ▶
                                                    </span>
                                                  </span>
                                                  {isExpanded && (
                                                    <div
                                                      style={{ marginTop: 8 }}
                                                    >
                                                      <div className="table-responsive">
                                                        <table
                                                          className="table table-sm table-bordered align-middle"
                                                          style={{
                                                            fontSize: 13,
                                                            marginBottom: 0,
                                                            minWidth: 600,
                                                          }}
                                                        >
                                                          <thead>
                                                            <tr>
                                                              <th
                                                                style={{
                                                                  minWidth: 180,
                                                                  height: 35,
                                                                  verticalAlign:
                                                                    "middle",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                Tên
                                                              </th>
                                                              <th
                                                                style={{
                                                                  minWidth: 140,
                                                                  height: 35,
                                                                  verticalAlign:
                                                                    "middle",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                Giá tiền
                                                              </th>
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            <tr>
                                                              <td
                                                                style={{
                                                                  height: 35,
                                                                  verticalAlign:
                                                                    "middle",
                                                                }}
                                                              >
                                                                Vé máy bay
                                                              </td>
                                                              <td
                                                                style={{
                                                                  height: 35,
                                                                  verticalAlign:
                                                                    "middle",
                                                                }}
                                                              >
                                                                {moneyFormatComma(
                                                                  fareType.gia_fare
                                                                )}
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td
                                                                style={{
                                                                  height: 35,
                                                                  verticalAlign:
                                                                    "middle",
                                                                }}
                                                              >
                                                                Thuế phí
                                                              </td>
                                                              <td
                                                                style={{
                                                                  height: 35,
                                                                  verticalAlign:
                                                                    "middle",
                                                                }}
                                                              >
                                                                {moneyFormatComma(
                                                                  fareType.thue + fareType.phi_dai_ly + (chuyenBay.ve.hang_bay == "uAPI" ? p.gia_ve.slice(1).reduce((sum, item) => sum + (item.phi_dai_ly || 0), 0) : 0)
                                                                )}
                                                              </td>
                                                            </tr>
                                                            {/* Hành lý */}
                                                            {hanhLyArr.map(
                                                              (hanhLy, i) => (
                                                                <tr
                                                                  key={
                                                                    "baggage-" +
                                                                    i
                                                                  }
                                                                >
                                                                  <td
                                                                    style={{
                                                                      height: 35,
                                                                      verticalAlign:
                                                                        "middle",
                                                                    }}
                                                                  >
                                                                    {hanhLy.ten}
                                                                    (
                                                                    {
                                                                      hanhLy.so_kg
                                                                    }
                                                                    kg)
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      height: 35,
                                                                      verticalAlign:
                                                                        "middle",
                                                                    }}
                                                                  >
                                                                    {moneyFormatComma(
                                                                      hanhLy.gia_net ||
                                                                        0
                                                                    )}
                                                                  </td>
                                                                </tr>
                                                              )
                                                            )}

                                                            {/* Ghế */}
                                                            {gheArr.map(
                                                              (ghe, i) => (
                                                                <tr
                                                                  key={
                                                                    "seat-" + i
                                                                  }
                                                                >
                                                                  <td
                                                                    style={{
                                                                      height: 35,
                                                                      verticalAlign:
                                                                        "middle",
                                                                    }}
                                                                  >
                                                                    Ghế:{" "}
                                                                    {ghe.so_ghe}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      height: 35,
                                                                      verticalAlign:
                                                                        "middle",
                                                                    }}
                                                                  >
                                                                    {moneyFormatComma(
                                                                      ghe.gia_net ||
                                                                        0
                                                                    )}
                                                                  </td>
                                                                </tr>
                                                              )
                                                            )}
                                                            {/* Dịch vụ */}
                                                            {dvArr.map(
                                                              (dv, i) => (
                                                                <tr
                                                                  key={
                                                                    "service-" +
                                                                    i
                                                                  }
                                                                >
                                                                  <td
                                                                    style={{
                                                                      height: 35,
                                                                      verticalAlign:
                                                                        "middle",
                                                                    }}
                                                                  >
                                                                    {dv.ten_hien_thi ||
                                                                      dv.ten}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      height: 35,
                                                                      verticalAlign:
                                                                        "middle",
                                                                    }}
                                                                  >
                                                                    {moneyFormatComma(
                                                                      dv.gia_net ||
                                                                        0
                                                                    )}
                                                                  </td>
                                                                </tr>
                                                              )
                                                            )}
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                      )
                                    })
                                  }
                                </div>
                              )
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Tổng tiền phải thanh toán */}
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: 16,
                      marginTop: 12,
                      background: "#f5f7fa",
                      borderRadius: 8,
                      padding: "14px 20px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
                    }}
                  >
                    Tổng tiền phải thanh toán
                    <span
                      style={{
                        color: "#1976d2",
                        marginLeft: 8,
                        fontSize: 20,
                      }}
                    >
                      {moneyFormatComma(
                        responseChuyenBay
                          .map((item) => item.ve.gia_dai_ly)
                          .reduce((a, b) => a + b, 0),
                        false
                      )}
                    </span>
                  </div>
                  <div>
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-primary mt-3"
                        style={{
                          minWidth: 150,
                          fontWeight: 600,
                          fontSize: 14,
                          borderRadius: 8,
                          boxShadow: "0 2px 8px rgba(25,118,210,0.15)",
                          padding: "12px 24px",
                        }}
                        onClick={() => {
                          navigate("/");
                        }}
                      >
                        Tiếp tục đặt vé
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {sweetAlert.isShow === true && (
        <SweetAlert {...sweetAlert.baseProps}>
          {sweetAlert.baseProps.ContentRender}
        </SweetAlert>
      )}
    </section>
  );
};

export default Response;
